import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../store/auth';
import { useSite } from '../store/site';

export default function SiteSelect() {
  const { user, logout } = useAuth();
  const { setSite } = useSite();
  const nav = useNavigate();
  const [sites, setSites] = useState(null);
  const isOffice = ['BUREAU','ADMIN'].includes(user?.role);

  useEffect(() => {
    api.get('/sites').then(({ data }) => {
      const actifs = data.filter(s => s.statut === 'ACTIF');
      if (actifs.length === 1 && !isOffice) { pick(actifs[0]); return; }
      setSites(data);
    }).catch(() => setSites([]));
    // eslint-disable-next-line
  }, []);

  function pick(s) {
    setSite(s);
    nav(isOffice ? '/dashboard' : '/rapport', { replace: true });
  }

  if (sites === null) return <div style={st.center}>Chargement…</div>;

  return (
    <div style={st.page}>
      <div style={st.card}>
        <img src="/logo.png" alt="LIDWORK" style={{ width:'100%', maxWidth:220, display:'block', margin:'0 auto 8px' }}/>
        <h2 style={st.title}>Choisir un chantier</h2>
        <p style={st.sub}>Connecté : {user?.name}</p>
        {sites.length === 0 && (
          <p style={{ color:'#C62828', textAlign:'center', margin:'16px 0' }}>
            Aucun chantier affecté à votre compte. Contactez l'administrateur.
          </p>
        )}
        {sites.map(s => (
          <button key={s.id} style={{ ...st.siteBtn, opacity: s.statut==='ACTIF'?1:.55 }} onClick={() => pick(s)}>
            <div style={{ textAlign:'left' }}>
              <div style={{ fontWeight:700, fontSize:15 }}>{s.nom}</div>
              <div style={{ fontSize:12, color:'#666' }}>
                {[s.client, s.ville].filter(Boolean).join(' – ')}
                {s._count ? ` · ${s._count.accessPoints} AP · ${s._count.reports} rapports` : ''}
              </div>
            </div>
            <span style={{ ...st.badge,
              background: s.statut==='ACTIF' ? '#e8f5e9' : '#eee',
              color: s.statut==='ACTIF' ? '#2E7D32' : '#888' }}>
              {s.statut === 'ACTIF' ? 'Actif' : s.statut === 'TERMINE' ? 'Terminé' : 'Archivé'}
            </span>
          </button>
        ))}
        <button style={st.logout} onClick={logout}>Déconnexion</button>
      </div>
    </div>
  );
}

const st = {
  page:{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
         background:'linear-gradient(135deg,#1E3A6E 0%,#2E75B6 100%)', padding:16 },
  card:{ background:'#fff', borderRadius:16, padding:28, width:'100%', maxWidth:440,
         boxShadow:'0 8px 32px rgba(0,0,0,.2)' },
  title:{ fontSize:19, fontWeight:800, color:'#1E3A6E', textAlign:'center' },
  sub:{ fontSize:13, color:'#666', textAlign:'center', margin:'4px 0 18px' },
  siteBtn:{ width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center',
            gap:10, background:'#f7f9fc', border:'1.5px solid #e0e6f0', borderRadius:12,
            padding:'12px 14px', marginBottom:8, cursor:'pointer' },
  badge:{ fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, whiteSpace:'nowrap' },
  logout:{ width:'100%', marginTop:14, background:'none', border:'none', color:'#888',
           fontSize:13, textDecoration:'underline', cursor:'pointer' },
  center:{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff',
           background:'linear-gradient(135deg,#1E3A6E 0%,#2E75B6 100%)' },
};
